import { CKContainerProps } from 'clearkit';
import React, { FC } from 'react';

import { PageLayoutTabs } from './PageLayoutTabs';

type BreadcrumbRouteHeadingProps = CKContainerProps<HTMLHeadingElement> & {
  breadcrumbs: {
    [key: number]: string;
  };
  pageTitle: string;
  routes: {
    [key: number]: string;
  };
  tabIndex: number;
};

export const BreadcrumbRouteHeading: FC<BreadcrumbRouteHeadingProps> = ({
  breadcrumbs,
  pageTitle,
  routes,
  tabIndex,
  ...rest
}) => {
  const breadcrumb = breadcrumbs[tabIndex as keyof typeof breadcrumbs];

  return breadcrumb ? (
    <PageLayoutTabs.Breadcrumb
      {...rest}
      breadcrumbs={[
        {
          title: pageTitle,
          path: routes[0],
        },
      ]}
    >
      {breadcrumb}
    </PageLayoutTabs.Breadcrumb>
  ) : (
    <PageLayoutTabs.Heading {...rest}>{pageTitle}</PageLayoutTabs.Heading>
  );
};
BreadcrumbRouteHeading.displayName = 'PageLayout.Heading';
